import { Phone, MessageCircle } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL } from "@/siteConfig";

const StickyBar = () => (
    <div
        data-testid="sticky-mobile-bar"
        className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 gap-3 border-t border-white/10 bg-[#0B0F17]/85 px-3 pt-3 shadow-[0_-8px_30px_rgba(0,0,0,0.45)] backdrop-blur-xl md:hidden"
        style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
    >
        <a
            href={PHONE_TEL}
            data-testid="sticky-mobile-call-btn"
            className="flex items-center justify-center gap-2 rounded-xl bg-blue-600 py-3.5 text-sm font-extrabold text-white"
        >
            <Phone size={18} />
            اتصل الآن
        </a>
        <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="sticky-mobile-whatsapp-btn"
            className="flex items-center justify-center gap-2 rounded-xl bg-emerald-600 py-3.5 text-sm font-extrabold text-white"
        >
            <MessageCircle size={18} />
            واتساب
        </a>
    </div>
);

export default StickyBar;
